import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from './../../../model/cliente/pageable/responsePageable.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CentroCustoModel } from 'app/model/cliente/centrocusto.model';
import { CentroCustoService } from 'app/service/cliente/centro-custo.service';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-centro-custo',
  templateUrl: './centro-custo.component.html',
  styleUrls: ['./centro-custo.component.scss']
})
export class CentroCustoComponent implements OnInit {

  @ViewChild('cardEdicao') elementRef: ElementRef;
  @ViewChild('centroCustoInput') centroCustoInput: ElementRef;

  centroCusto = {} as CentroCustoModel;
  centroCustos: CentroCustoModel[];
  edited = false;
  editado = false;
  errorAlert = false;
  successDelete = false;
  submit = false;
  page: ResponsePageable;
  pageAtual = 0;
  superUser = false;
  public loading = false;
  public arrayString: string;
  public creatorCentroCusto = false;
  public editorCentroCusto = false;
  public listaCentroCusto = false;
  public deletaCentroCusto = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(
    private centroCustoService: CentroCustoService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService
  ) { }

  ngOnInit() {
    // Chamando o método de listagem
    this.getCentroCusto(0, 10);
    this.getAuthority();
  }

  onSubmit() {
    this.submit = true;
   }

   postSubmit() {
     this.submit = false;
     this.centroCusto.id = undefined;
     this.centroCustoInput.nativeElement.value = '';
     this.centroCusto.descricao = null;
  }

  scroll() {
    this.elementRef.nativeElement.scrollIntoView();
  }

  changePage(event) {
    this.getCentroCusto(event.page, event.size);
    this.pageAtual = event.page;
  }

  getCentroCusto(page: number, size: number) {
    this.centroCustoService.getListaCentroCusto(page, size).subscribe( data => {
      this.page = data;
      this.centroCustos = this.page.content;
      this.loading = false;
    }, error => {
      console.error(error);
    });
  }

  manterCentroCusto() {
    this.centroCustoService.postCentroCusto(this.centroCusto).subscribe( data => {
      // Edição
      if (this.centroCusto.id !== undefined) {
        this.centroCusto = new CentroCustoModel();
        this.getCentroCusto(this.pageAtual, 10);
        this.postSubmit();
        this.openSnackBarSuccess('Centro de Custo atualizado com sucesso !');
      } else {
        this.centroCusto = new CentroCustoModel();
        this.getCentroCusto(0, 10);
        this.postSubmit();
        this.openSnackBarSuccess('Centro de Custo salvo com sucesso !');
      }
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro !');
    });
  }

  // Função para pegar o centro de custo que será editado
  getDadosEditcao(centroCusto: CentroCustoModel) {
    this.centroCusto = { ...centroCusto };
  }

  confirmeExcluir(id: number) {
    const confirme = confirm('Deseja excluir este Centro de Custo ?');
    if (confirme) {
      this.apagarCentroCusto(id);
    } else {
      console.log('Cancelou exclusão.');
    }
  }

  // Função para excluir um Centro de Custo
  apagarCentroCusto(id: number) {
    this.centroCustoService.deleteCentroCusto(id).subscribe(() => {
      this.openSnackBarSuccess('Centro de Custo excluído com sucesso !');
      this.getCentroCusto(0, 10);
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro ao excluir! Este Centro de Custo está sendo usado por um cliente.');
    });
  }


  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorCentroCusto = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorCentroCusto = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaCentroCusto = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaCentroCusto = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // SnackBares
openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}

}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/centro-custo/centro-custo.component.ts